"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
// Models
const FilterWithValue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/FilterWithValue"));
// Vue
const FilteringItem_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/FilteringItem.vue"));
const debounce_1 = require("@common/tsutils/debounce");
let Filtering = class Filtering extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.expanded = false;
        this.filterWithValues = [
            new FilterWithValue_1.default(),
        ];
    }
    filtersUsed() {
        return this.filterWithValues.filter((f) => f.filter != null).length;
    }
    expand() {
        this.expanded = !this.expanded;
        this.updateFilterSection();
    }
    updateFilterSection() {
        this.$emit('updatedFilter', this.expanded, this.filterWithValues.length);
    }
    addFilter() {
        this.filterWithValues.push(new FilterWithValue_1.default());
        this.updateFilterSection();
    }
    removeFilter(fvalue) {
        const idx = this.filterWithValues.findIndex(fv => {
            return fv === fvalue;
        });
        this.filterWithValues.splice(idx, 1);
        this.onChangeFilterValue();
        this.updateFilterSection();
    }
    removeAllFilters() {
        this.filterWithValues = [];
        this.onChangeFilterValue();
        this.updateFilterSection();
    }
    onChangeFilterValue() {
        const active_filters = this.filterWithValues.filter(fwv => {
            if (!fwv.filter)
                return false;
            if (fwv.value.type === 'empty')
                return false;
            return true;
        });
        this.$emit('filter', active_filters);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Filtering.prototype, "heatmap", void 0);
__decorate([
    (0, debounce_1.Debounce)(1000)
], Filtering.prototype, "onChangeFilterValue", null);
Filtering = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Filter: lucide_vue_next_1.Filter,
            Plus: lucide_vue_next_1.Plus,
            SlidersHorizontal: lucide_vue_next_1.SlidersHorizontal,
            FilteringItem: FilteringItem_vue_1.default
        }
    })
], Filtering);
exports.default = Filtering;
